import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import globalSettingsStores from '../../../../../stores/settings-stores';

export const deleteBuildingIdOperations = async (
  buildingId: number,
  setBuildingId: (buildingId: number | null) => void,
) => {
  try {
    setBuildingId(buildingId);

    const res = await appApi.deleteBuilding(buildingId);
    if (res.data.ok) {
      const branchesData = await appApi.getBranches();
      globalSettingsStores.fetchSetting();
      toast.success('המבנה נמחק בהצלחה');
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }
    setBuildingId(null);
  } catch (e) {
    setBuildingId(null);
    console.error(
      `deleteBuildingIdOperations failed with the buildingId: ${buildingId}, and the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
